export class BrowserDetectionService {
    constructor() {
        this.opera = false;
        this.fireFox = false;
        this.safari = false;
        this.ie = false;
        this.edge = false;
        this.chrome = false;
        this.blink = false;
        this.loaded = false;
    }

    get isOpera() {
        this.load();
        return this.opera;
    }

    get isFireFox() {
        this.load();
        return this.fireFox;
    }

    get isSafari() {
        this.load();
        return this.safari;
    }

    get isIE() {
        this.load();
        return this.ie;
    }

    get isEdge() {
        this.load();
        return this.edge;
    }

    get isChrome() {
        this.load();
        return this.chrome;
    }

    get isBlink() {
        this.load();
        return this.blink;
    }

    get type() {
        return this.isOpera
            ? 'opera'
            : this.isFireFox
            ? 'firefox'
            : this.isSafari
            ? 'safari'
            : this.isIE
            ? 'ie'
            : this.isIE
            ? 'edge'
            : this.isChrome
            ? 'chrome'
            : this.isBlink
            ? 'blink'
            : '';
    }

    load() {
        if (!this.loaded) {
            this.getBrowserType();
            this.loaded = true;
        }
    }

    getBrowserType() {
        this.opera =
            (!!window.opr && !!opr.addons) ||
            !!window.opera ||
            navigator.userAgent.indexOf(' OPR/') >= 0;
        // Firefox 1.0+
        this.fireFox = typeof InstallTrigger !== 'undefined';
        // At least Safari 3+: "[object HTMLElementConstructor]"
        this.safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
        // Internet Explorer 6-11
        this.ie = /*@cc_on!@*/ false || !!document.documentMode;
        // Edge 20+
        this.edge = !this.ie && !!window.StyleMedia;
        // Chrome 1+
        this.chrome = !!window.chrome && !!window.chrome.webstore;
        // Blink engine detection
        this.blink = (this.chrome || this.opera) && !!window.CSS;
    }
}
